module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Bold.c101b4c1fc0e403af48c1578fedd5066.ttf";